export const AVAILABILITY_SUBSCRIPTION_CONFIG_KEY = 'rail_avail_alert_config';

export const AVAILABILITY_SUBSCRIPTION_CONFIG_FALLBACK = {
  "widget": {
    "enabledText": "We'll notify you when seats are about to be sold out",
    "disabledText": "Get Notified when seats are about to be sold out"
  },
  "bottomSheet": {
    "enabled": {
      "title": "Alert Created",
      "description": "We'll keep track of availabilty and tell you the right time to book"
    },
    "disabled": {
      "title": "Get notified before seats are sold out",
      "description": "We'll keep track of availabilty and tell you the right time to book"
    }
  }
};

export const AVAILABILITY_ALERT_SHOWN_DWEB = 'availability_alert_shown_dweb';
export const AVAILABILITY_ALERT_SUBSCRIBED_DWEB = 'availability_alert_subscribed_dweb';

export const AVAILABILITY_ALERT_SET_SUCCESSFULLY = 'Availability Alert set successfully';
export const AVAILABILITY_ALERT_REMOVED_SUCCESSFULLY = 'Availability Alert removed successfully'; 